import { motion } from "framer-motion";
import { useParams, useNavigate } from "react-router-dom";
import img1 from '../../../Assets/Home/blog1.jpeg';
import img2 from '../../../Assets/Home/blog2.jpeg';


// ─── Full blog data ────────────────────────────────────────────────────────────
export const blogs = [
  {
    id: 1,
    image:img1,
    date: "March 15, 2025",
    readTime: "5 min read",
    category: "EVENT",
    tag: "Foundation Day",
    title:
      "18 Years of Growth, Innovation & Togetherness: KGS Technology Group Foundation Day Celebration",
    excerpt:
      "KGS Technology Group proudly celebrated its 18th Foundation Day, marking another milestone in its journey of growth, innovation, and excellence.",
    author: { name: "KGS Media Team", avatar: "https://i.pravatar.cc/48?u=kgs1" },
    sections: [
      {
        heading: "A Celebration of Growth & Success",
        body: "Over the past 18 years, KGS Technology Group has continued to grow as a trusted name in technology and workforce solutions. The Foundation Day celebration reflected the company's strong values, collaborative work culture, and commitment to innovation. The event served as a moment to celebrate achievements, recognize employee contributions, and look ahead toward future growth opportunities.",
      },
      {
        heading: "Grand Light-Up Ceremony",
        body: "The celebration also featured a special light-up ceremony symbolizing growth, progress, and the bright future ahead for KGS Technology Group. The moment represented the company's journey of excellence and its continued focus on innovation and expansion.",
      },
      {
        heading: "Cultural Programs Added Energy to the Event",
        body: "One of the biggest highlights of the celebration was the vibrant cultural program organized by employees. The performances showcased creativity, talent, and team spirit, creating an energetic atmosphere throughout the event. The cultural activities reflected the strong employee engagement and positive workplace culture that continue to strengthen the organization.",
      },
      {
        heading: "Strategic partnership with HiView.ai",
        body: "A major highlight of the event was the important MoU announcement by HiView.ai, reflecting the organization's growing focus on AI-driven innovation and future-ready technology solutions. The announcement reinforced the company's vision toward digital transformation, intelligent automation, and next-generation business solutions.",
      },
      {
        heading: "Sequoia Magazine Release",
        body: "The Foundation Day celebration also featured the official release of the Sequoia Magazine, focused on employee articles and office culture. The magazine highlighted employee experiences, workplace creativity, team stories, and the collaborative environment within KGS Technology Group. The initiative reflected the company's people-first culture and encouraged employee engagement, knowledge sharing, and internal collaboration.",
      },
      {
        heading: "Looking Ahead",
        body: "The 18th Foundation Day celebration was not just about celebrating the past, but also about embracing the future. With innovation, teamwork, and strong leadership at its core, KGS Technology Group continues to move forward with a vision for greater success in the technology industry. As the organization enters another year of growth, the celebration stands as a reminder of its commitment to excellence, culture, and continuous innovation.",
      },
    ],
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=1200&auto=format&fit=crop&q=80",
    date: "April 02, 2025",
    readTime: "4 min read",
    category: "CULTURE",
    tag: "Cricket Match",
    title:
      "Strengthening Workplace Culture Through Cricket at KGS Technology Group",
    excerpt:
      "At KGS Technology Group, building a strong workplace culture goes beyond day-to-day operations — cricket has become an important part of that culture.",
    author: { name: "KGS Culture Team", avatar: "https://i.pravatar.cc/48?u=kgs2" },
    sections: [
      {
        heading: "More Than Just a Game",
        body: "At KGS Technology Group, building a strong workplace culture goes beyond day-to-day operations. The organization believes that teamwork, collaboration, and employee engagement are strengthened through meaningful activities that bring people together — and cricket has become an important part of that culture. Corporate cricket activities at KGS Technology Group are designed to encourage team bonding, communication, and collaboration among employees across different departments. These events create opportunities for employees to connect outside the workplace while promoting a positive and energetic work environment.",
      },
      {
        heading: "Encouraging Teamwork & Collaboration",
        body: "Cricket naturally reflects many of the qualities that drive successful teams within an organization — coordination, leadership, strategy, and collaboration. Through these activities, employees develop stronger interpersonal connections and learn the value of working together toward a common goal. The participation and enthusiasm shown during the matches reflect the company's strong employee-centric culture and collaborative spirit.",
      },
      {
        heading: "Promoting Employee Engagement",
        body: "Sports activities like cricket contribute significantly to employee engagement by creating a healthy balance between work and recreation. Such initiatives help employees interact in a more relaxed environment, strengthening workplace relationships and encouraging a sense of unity across teams. These activities also support: Team bonding, Employee motivation, Workplace positivity, Cross-team interaction, and a Healthy work culture.",
      },
      {
        heading: "Building a Positive Workplace Environment",
        body: "At KGS Technology Group, employee engagement initiatives are an important part of building a dynamic and people-focused workplace. Cricket matches and sports events not only encourage participation but also reinforce the organization's commitment to creating a collaborative and inclusive work culture. By promoting activities that combine teamwork, energy, and employee interaction, KGS Technology Group continues to foster an environment where employees grow together both professionally and personally.",
      },
    ],
  },
  {
    id: 3,
    image:img2,
    date: "April 28, 2025",
    readTime: "6 min read",
    category: "NEWS",
    tag: "AI Innovation",
    title:
      "KGS Technology Group & HiView.ai Mark a Major AI Transformation Milestone with Supreme Industries.",
    excerpt:
      "KGS Technology Group and HiView.ai have achieved a significant milestone with the successful launch of their major AI-driven transformation project at Supreme Industries Ltd., one of India's leading polymer manufacturers.",
    author: { name: "KGS News Desk", avatar: "https://i.pravatar.cc/48?u=kgs3" },
    sections: [
      {
        heading: "A Landmark AI Partnership",
        body: "KGS Technology Group and HiView.ai have achieved a significant milestone with the successful launch of their first major AI-driven transformation project at Supreme Industries Ltd., one of India's leading polymer manufacturers. The joint team recently conducted a strategic visit to the company's Malanpur facility in Gwalior, officially marking the beginning of a powerful collaboration focused on driving intelligent manufacturing and operational efficiency through advanced AI solutions.",
      },
      {
        heading: "Driving AI-Powered Manufacturing Transformation",
        body: "This project represents an important breakthrough for the KGS Technology Group and HiView.ai partnership in the Indian manufacturing and polymer industry. By combining KGS's industry expertise with HiView.ai's advanced AI capabilities, the collaboration aims to deliver smarter, data-driven business operations. The AI-powered solution focuses on: Precision sales forecasting for improved market planning, Intelligent production planning to enhance operational efficiency, Smart material management for optimized supply chain performance, and Data-driven decision-making across manufacturing processes. The initiative is designed to help businesses improve forecasting accuracy, streamline operations, and increase overall efficiency in a rapidly evolving market environment.",
      },
      {
        heading: "A Strong Partnership Focused on Innovation",
        body: "The successful project kick-off at the Malanpur facility highlights the growing impact of AI and digital transformation within the manufacturing sector. The collaboration between KGS Technology Group and HiView.ai reflects a shared vision of building intelligent, future-ready industrial solutions. The visit also reinforced the strength of the partnership and its ability to create meaningful transformation through technology, innovation, and strategic execution.",
      },
      {
        heading: "Looking Ahead",
        body: "This milestone marks the beginning of a larger journey toward AI-driven manufacturing innovation. With a strong foundation now established, KGS Technology Group and HiView.ai are looking forward to expanding their impact across industries through advanced analytics, automation, and intelligent operational solutions. The collaboration stands as a strong example of how AI and technology partnerships can redefine the future of manufacturing in India.",
      },
    ],
  },
];

const categoryColors = {
  EVENT: { bg: "bg-violet-600/20", text: "text-violet-300", border: "border-violet-500/30" },
  CULTURE: { bg: "bg-emerald-600/20", text: "text-emerald-300", border: "border-emerald-500/30" },
  NEWS: { bg: "bg-orange-600/20", text: "text-orange-300", border: "border-orange-500/30" },
};

// ─── BlogDetails ───────────────────────────────────────────────────────────────
export default function BlogDetails({ onBack }) {
 const { id } = useParams();
 

  const blog = blogs.find((b) => b.id === Number(id));

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center text-gray-900 justify-center">
        Blog not found
      </div>
    );
  }

  const colors =
    categoryColors[blog.category] || categoryColors.NEWS;

  return (
    <>
    <div className="min-h-screen ">
      {/* Hero */}
      <div className="relative h-[46vh] min-h-[360px] w-full overflow-hidden  bg-gradient-to-br from-gray-200 via-gray-100 to-gray-300 ">
        {/* Dark gradient */}
        {/* <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c0f] via-[#0c0c0f]/60 to-transparent" /> */}


        {/* Hero text overlay */}
        <div className="absolute bottom-0 left-0 right-0 px-6 pb-10 max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
          >
            <h1
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-jakarta font-bold text-gray-700 leading-tight"
              style={{ fontFamily: "'Georgia', serif" }}
            >
              {blog.title}
            </h1>
          </motion.div>
        </div>
      </div>

      {/* Content area */}
      <div className="max-w-4xl mx-auto px-6 py-12">
       <div className="mb-10 overflow-hidden rounded-3xl shadow-xl border border-gray-200">
                <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-[260px] sm:h-[450px] object-cover"
                />
                </div>
        {/* Excerpt */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="text-xl text-gray-700 leading-relaxed font-medium mb-12 border-l-4 border-orange-500 pl-5"
        >
          {blog.excerpt}
        </motion.p>

        {/* Sections */}
        <div className="space-y-10">
          {blog.sections.map((section, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.55 + i * 0.08, duration: 0.5 }}
            >
              <h2
                className="text-xl sm:text-2xl font-bold text-gray-900 mb-3"
                style={{ fontFamily: "'Georgia', serif" }}
              >
                {section.heading}
              </h2>
              <p className="text-gray-600 leading-[1.85] text-[1.02rem]">{section.body}</p>
            </motion.div>
          ))}
        </div>

        {/* Divider */}
        <div className="my-14 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent" />

        {/* Related blogs */}
        <RelatedBlogs current={blog} />
      </div>
    </div>
    </>
  );
}

// ─── Related Blogs strip ───────────────────────────────────────────────────────
function RelatedBlogs({ current }) {
  const related = blogs.filter((b) => b.id !== current.id);
  const navigate = useNavigate();
  return (
    <div>
      <h3 className="md:text-lg font-black text-gray-900 mb-6 tracking-tight uppercase text-sm">
        More Stories
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {related.map((blog) => {
          const colors = categoryColors[blog.category] || categoryColors.NEWS;
          return (
            <motion.div
             onClick={()=>{
                  navigate(`/blogDetails/${blog.id}`);
                  window.scrollTo({
                    top:0,
                    behavior:"smooth"
                  })
                }}
              key={blog.id}
              whileHover={{ y: -4 }}
              transition={{ duration: 0.25 }}
              className="flex gap-4 p-4 rounded-xl bg-gray-50 border border-gray-200 hover:border-orange-400 cursor-pointer transition-colors duration-200 group"
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="w-20 h-20 rounded-lg object-cover flex-shrink-0"
              />
              <div className="flex flex-col justify-between min-w-0">
                {/* <span
                  className={`text-[0.65rem] font-black tracking-widest uppercase ${colors.text} mb-1`}
                >
                  {blog.category}
                </span> */}
                <p
                  className="text-gray-900 text-sm font-bold line-clamp-2 group-hover:text-orange-300 transition-colors duration-200 leading-snug"
                  style={{ fontFamily: "'Georgia', serif" }}
                >
                  {blog.title}
                </p>
                <span className="text-gray-500 text-xs mt-1">{blog.date}</span>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}